export default "__VITE_ASSET__62bc11aa__"